module.exports = __webpack_public_path__ + "promo/app-store-badges/apple-app-store-it-a8a03c5c39afb2c76a6381b14d4f1b5f.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/apple-app-store-it.svg
// module id = fDjo
// module chunks = 22